export const startDateIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.08278 2.5V4.03947M12.3146 2.5V4.03947M2.5 13.2763V5.57895C2.5 4.72872 3.19381 4.03947 4.04967 4.03947H13.3477C14.2035 4.03947 14.8974 4.72872 14.8974 5.57895V8.14474M2.5 13.2763C2.5 14.1265 3.19381 14.8158 4.04967 14.8158H9.38742M2.5 13.2763V8.14474C2.5 7.29451 3.19381 6.60526 4.04967 6.60526H13.3477C14.2035 6.60526 14.8974 7.29451 14.8974 8.14474M14.8974 8.14474V9.34211M10.851 13.1908H13.1755M13.1755 13.1908H15.5M13.1755 13.1908V10.8816M13.1755 13.1908V15.5"
      stroke="#A88CA4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const endDateIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.0625 2.25V3.9375M12.9375 2.25V3.9375M2.25 14.0625V5.625C2.25 4.69302 3.00552 3.9375 3.9375 3.9375H14.0625C14.9945 3.9375 15.75 4.69302 15.75 5.625V9.84375M2.25 14.0625C2.25 14.9945 3.00552 15.75 3.9375 15.75H10M2.25 14.0625V8.4375C2.25 7.50552 3.00552 6.75 3.9375 6.75H14.0625C14.9945 6.75 15.75 7.50552 15.75 8.4375"
      stroke="#A88CA4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2 13.1154V12.1538C15.2 11.5166 14.6627 11 14 11C13.3373 11 12.8 11.5166 12.8 12.1538V13.1154M12.6 16H15.4C15.7314 16 16 15.7417 16 15.4231V13.6923C16 13.3737 15.7314 13.1154 15.4 13.1154H12.6C12.2686 13.1154 12 13.3737 12 13.6923V15.4231C12 15.7417 12.2686 16 12.6 16Z"
      stroke="#A88CA4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const annualLicenseCostIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.6875 14.0625C5.7879 14.0625 9.7602 14.6109 13.5351 15.6384C14.0803 15.7868 14.625 15.3814 14.625 14.8163V14.0625M2.8125 3.375V3.9375C2.8125 4.24816 2.56066 4.5 2.25 4.5H1.6875M1.6875 4.5V4.21875C1.6875 3.75276 2.06526 3.375 2.53125 3.375H15.1875M1.6875 4.5V11.25M15.1875 3.375V3.9375C15.1875 4.24816 15.4393 4.5 15.75 4.5H16.3125M15.1875 3.375H15.4688C15.9347 3.375 16.3125 3.75276 16.3125 4.21875V11.5313C16.3125 11.9972 15.9347 12.375 15.4688 12.375H15.1875M16.3125 11.25H15.75C15.4393 11.25 15.1875 11.5018 15.1875 11.8125V12.375M15.1875 12.375H2.8125M2.8125 12.375H2.53125C2.06526 12.375 1.6875 11.9972 1.6875 11.5313V11.25M2.8125 12.375V11.8125C2.8125 11.5018 2.56066 11.25 2.25 11.25H1.6875M11.25 7.875C11.25 9.11764 10.2426 10.125 9 10.125C7.75736 10.125 6.75 9.11764 6.75 7.875C6.75 6.63236 7.75736 5.625 9 5.625C10.2426 5.625 11.25 6.63236 11.25 7.875ZM13.5 7.875H13.5056V7.88063H13.5V7.875ZM4.5 7.875H4.50563V7.88063H4.5V7.875Z"
      stroke="#A88CA4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const numberOfLicensesIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.75 9H9.5625M6.75 11.25H9.5625M6.75 13.5H9.5625M11.8125 14.0625H13.5C14.432 14.0625 15.1875 13.307 15.1875 12.375V4.58116C15.1875 3.72993 14.5538 3.00761 13.7054 2.93721C13.4255 2.91397 13.1446 2.89394 12.8629 2.87714M8.51214 2.87714C8.46362 3.03451 8.4375 3.20171 8.4375 3.375C8.4375 3.68566 8.68934 3.9375 9 3.9375H12.375C12.6857 3.9375 12.9375 3.68566 12.9375 3.375C12.9375 3.20171 12.9114 3.03451 12.8629 2.87714M8.51214 2.87714C8.72457 2.18818 9.36631 1.6875 10.125 1.6875H11.25C12.0087 1.6875 12.6504 2.18818 12.8629 2.87714M8.51214 2.87714C8.2304 2.89394 7.94953 2.91397 7.66956 2.93721C6.82124 3.00761 6.1875 3.72993 6.1875 4.58117V6.1875M6.1875 6.1875H3.65625C3.19026 6.1875 2.8125 6.56526 2.8125 7.03125V15.4688C2.8125 15.9347 3.19026 16.3125 3.65625 16.3125H10.9688C11.4347 16.3125 11.8125 15.9347 11.8125 15.4688V7.03125C11.8125 6.56526 11.4347 6.1875 10.9688 6.1875H6.1875ZM5.0625 9H5.06813V9.00563H5.0625V9ZM5.0625 11.25H5.06813V11.2556H5.0625V11.25ZM5.0625 13.5H5.06813V13.5056H5.0625V13.5Z"
      stroke="#A88CA4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const priceOfUnitsIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.17601 2.25H3.9375C3.00552 2.25 2.25 3.00552 2.25 3.9375V7.17601C2.25 7.62357 2.42779 8.05279 2.74426 8.36926L9.93009 15.5551C10.4541 16.0791 11.2649 16.2088 11.8849 15.8029C13.4453 14.7813 14.7813 13.4453 15.8029 11.8849C16.2088 11.2649 16.0791 10.4541 15.5551 9.93009L8.36926 2.74426C8.05279 2.42779 7.62357 2.25 7.17601 2.25Z"
      stroke="#A88CA4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 4.5H4.50563V4.50563H4.5V4.5Z" stroke="#A88CA4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
